import { useEffect } from 'react';
import localStorage from '@utils/localStorage';

const TIMELINE_GLOBAL_FILTERS_LOCALSTORAGE_KEY = 'user-timeline-global-filters';

export const genGlobalFiltersLocalstorageKey = (key: string) =>
  `${TIMELINE_GLOBAL_FILTERS_LOCALSTORAGE_KEY}-${key}`;

export const useGlobalFitlers = (key: string | null) => {
  let globalFilters;
  if (key) {
    globalFilters = localStorage.get(genGlobalFiltersLocalstorageKey(key));
  }

  useEffect(() => {
    // remove expired global filters
    const keys = localStorage.keys();
    keys.forEach((k) => {
      if (k.startsWith(TIMELINE_GLOBAL_FILTERS_LOCALSTORAGE_KEY)) {
        localStorage.get(k);
      }
    });
  }, []);

  return globalFilters;
};
